module.exports = __webpack_public_path__ + "img/48-girl.d48f1ddc.svg";